import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  constructor(public http: HttpClient) {
    // console.log(this.url);
  }

  sipass = {
    url: {
      invitation: "https://a.sipass.io/i/",
    },
    api: {
      v2: {
        shortLink: "https://createshortlink-k3dpkcvqzq-uc.a.run.app",
      },
    },
  };

  url = "https://us-central1-sipass.cloudfunctions.net/tickets";
  serverUrl = "https://us-central1-sipass.cloudfunctions.net";
  apiV2 = this.serverUrl + "/apiV2";
  apiV2a = this.apiV2 + "a";
  apiV2b = "https://apiv2b-k3dpkcvqzq-uc.a.run.app";
  // url = 'http://localhost:5001/sipass/us-central1/apiV2';
  urlInvitation = "https://sipass.io/invitation?i=";
  urlCoupons = "https://coupons.sipass.io/coupon/"; // 'https://sipass.io/coupon?i=';
  urlCouponsT = "https://coupons.sipass.io/t/";
  urlParking = "https://panel.sipass.io/parking";
  urlParkingT = "https://t.sipass.io/g";
  linkInvitation = "https://g.sipass.io/";
  linkParking = "https://p.sipass.io/";
  linkCoupons = "https://c.sipass.io/";
  whatsAppApi = "https://api.whatsapp.com/send?";
  dynamicUrl =
    "https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=" +
    environment.firebase.apiKey;
  token: string;
  httpOptions: {
    "Content-Type": "application/x-www-form-urlencoded";
    "Access-Control-Allow-Origin": "*";
  };

  get(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams(),
      };
    }

    // Support easy query params for GET requests
    /*  if (params) {
      reqOpts.params = new HttpParams();
      for (const k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    } */

    return this.http.get(endpoint, reqOpts);
  }
  post(endpoint: string, body: any, reqOpts?: any, api?: string) {
    // this.url = 'http://localhost:5000/sipass/us-central1/apiV2';

    let url = this.serverUrl;
    const params = new HttpParams({
      fromObject: body,
    });
    if (!reqOpts) {
      reqOpts = this.httpOptions;
    }
    if (api === "apiV2") {
      url = this.apiV2;
    } else if (api === "apiV2a") {
      url = this.apiV2a;
    } else if (api === "apiV2b") {
      url = this.apiV2b;
    }
    return this.http.post(url + "/" + endpoint, params, reqOpts);
  }

  getShortLinkParking(
    installation: string,
    terminal: string,
    relay?: string,
    ver?: string,
    reqOpts?: any,
  ) {
    let r = "";
    if (relay) {
      r = "/" + relay;
    }
    let v = "";
    if (ver) {
      v = "/" + ver;
    }
    const body: any = {
      longLink: this.urlParkingT + "/" + installation + "/" + terminal + r + v,
    };
    console.log(body);
    const params = new HttpParams({
      fromObject: body,
    });
    const httpOptions = {
      "Content-Type": "application/json",
    };
    if (!reqOpts) {
      reqOpts = httpOptions;
    }
    return this.http.post(this.sipass.api.v2.shortLink, body, reqOpts);
  }

  getShortLinkCoupons(id: string, reqOpts?: any) {
    const body: any = {
      longDynamicLink: this.linkCoupons + "?link=" + this.urlCouponsT + id,
      suffix: {
        option: "SHORT",
      },
    };
    // console.log(body);
    const params = new HttpParams({
      fromObject: body,
    });
    const httpOptions = {
      "Content-Type": "application/json",
    };
    if (!reqOpts) {
      reqOpts = httpOptions;
    }
    return this.http.post(this.dynamicUrl, body, reqOpts);
  }

  getShortLinkCouponsAssociates(
    id: string,
    associateId: string,
    reqOpts?: any,
  ) {
    const body: any = {
      longDynamicLink:
        this.linkCoupons + "?link=" + this.urlCouponsT + id + "/" + associateId,
      suffix: {
        option: "SHORT",
      },
    };
    // console.log(body);
    const params = new HttpParams({
      fromObject: body,
    });
    const httpOptions = {
      "Content-Type": "application/json",
    };
    if (!reqOpts) {
      reqOpts = httpOptions;
    }
    return this.http.post(this.dynamicUrl, body, reqOpts);
  }

  postDss(body: any, reqOpts?: any) {
    const params = new HttpParams({
      fromObject: body,
    });
    if (!reqOpts) {
      reqOpts = this.httpOptions;
      if (body.token) {
        reqOpts = {
          headers: new HttpHeaders().set("Authorization", body.token),
        };
      }
    }
    return this.http.post(
      "https://us-central1-sipass.cloudfunctions.net/dss",
      params,
      reqOpts,
    );
  }

  postJson(endpoint: string, body: any, reqOpts?: any) {
    const params = new HttpParams({
      fromObject: body,
    });
    // Support easy query params for GET requests
    /*  if (params) {
      reqOpts.params = new HttpParams();
      for (const k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    } */

    return this.http.post(endpoint, params, reqOpts);
    //return this.http.get('https://us-central1-sipass.cloudfunctions.net/dss', reqOpts);
  }
  getJson(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams(),
      };
    }

    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (const k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return this.http.get(endpoint, reqOpts);
  }

  sendWhatsAppMessage(
    phoneNumber: string,
    installationName: string,
    condoName: string,
    depositType: string,
    depositAmount: number,
    vm: string,
  ) {
    const url = "https://graph.facebook.com/v19.0/114794401527241/messages"; // Asegúrate de usar la versión correcta de la API
    // Definir variables para el título, cuerpo y botón
    const body = {
      messaging_product: "whatsapp",
      to: phoneNumber,
      type: "template",
      template: {
        name: "manager_voucher",
        language: {
          code: "es_MX",
        },
        components: [
          {
            type: "header",
            parameters: [
              {
                type: "text",
                text: installationName,
              },
            ],
          },
          {
            type: "body",
            parameters: [
              {
                type: "text",
                text: condoName,
              },
              {
                type: "text",
                text: depositType,
              },
              {
                type: "text",
                text: depositAmount,
              },
            ],
          },
          {
            type: "button",
            sub_type: "url",
            index: "0",
            parameters: [
              {
                type: "text",
                text: vm,
              },
            ],
          },
        ],
      },
    };
    const token =
      "EAAXGOsMkHVMBAHTb53c9Qq4VibMs1MtezoZBxRvPdLYaSAcfzXDsfvwe8ZCaDx4aPMQ2p8BbUhWU0DrPgVdZCfebi6QWLaH7y5ujfqJ4x22uZAal6lK7PKQqPdpdp4aE4dfZCG9saSjZCnBdslh0ZCZBhjL1ZBY2czBfWc8gZBVRTFFyZCES0Tv73WE"; // Reemplaza esto con tu token de acceso real
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });

    return this.http.post(url, body, { headers: headers });
  }
}
